module.exports = __webpack_public_path__ + "img/alert-white.3f3bdeaf.svg";